<template lang="pug">
th.table-column-header(
  scope="col"
  :class="[header.class, 'text-' + (header.align || 'start'), { 'table-column--pinned': !!header.pin }]"
  :style="columnStyle"
  :aria-sort="sortable ? (sortIndex < 0 ? 'none' : descending ? 'descending' : 'ascending') : null"
)
  button.table-column-header__label(
    v-if="sortable"
    type="button"
    :aria-label="sortLabel"
    :title="header.text"
    @click="$emit('sort', header.value)"
  )
    span.table-column-header__text
      slot {{ header.text }}
    v-icon.table-column-header__sort(size="16" :class="{ 'table-column-header__sort--active': sortIndex >= 0 }") {{ descending ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
    span(v-if="options.multiSort && sortIndex >= 0").ml-1 {{ sortIndex + 1 }}
  div.table-column-header__label(v-else :title="header.text")
    span.table-column-header__text
      slot {{ header.text }}
  ColumnResize(
    :label="header.text"
    :width="header.width"
    :edge="header.pin === 'right' ? 'left' : 'right'"
    :min-width="header.minWidth || 80"
    @start="$emit('resize-start')"
    @resize="$emit('resize', $event)"
    @end="$emit('resize-end', $event)"
  )
</template>

<script>
import ColumnResize from './ColumnResize.vue'

export default {
  name: 'TableColumnHeader',
  components: { ColumnResize },
  props: {
    header: { type: Object, required: true },
    options: { type: Object, required: true },
    disableSort: { type: Boolean, default: false },
    columnStyle: { type: Object, default: () => ({}) }
  },
  computed: {
    sortable () { return !this.disableSort && this.header.sortable !== false },
    sortIndex () { return (this.options.sortBy || []).indexOf(this.header.value) },
    descending () { return this.sortIndex >= 0 && this.options.sortDesc[this.sortIndex] },
    sortLabel () {
      const action = this.sortIndex < 0 ? 'activateAscending' : this.descending
        ? (this.options.mustSort ? 'activateAscending' : 'activateNone') : 'activateDescending'
      return `${this.header.text}: ${this.$vuetify.lang.t('$vuetify.dataTable.ariaLabel.' + action)}`
    }
  }
}
</script>

<style lang="sass">
.table-column-header
  position: relative
  padding: 0 10px !important
  vertical-align: middle

  &__label
    display: flex
    align-items: center
    gap: 4px
    min-width: 0
    width: 100%
    min-height: 40px
    color: inherit
    font: inherit
    text-align: inherit

  button.table-column-header__label
    cursor: pointer

  &__text
    min-width: 0
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap

  &__sort
    flex-shrink: 0
    opacity: .3

    &--active
      opacity: 1

  &__label:hover &__sort, &__label:focus-visible &__sort
    opacity: 1
</style>
